export class RefreshDate  {

  asOfDate: Date ;

}
